import {ChangeEventHandler, useCallback, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectDetails} from '~/CreateFabricInvitation/reducers/details/selectors';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {initialState as init} from '~/common/fabric/reducers/details/reducer';
import {parseUSPhoneNumber} from '~/common/utils';
import {AddButtonWithTitle} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/AddButtonWithTitle/AddButtonWithTitle';
import {InputWithRemove} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/InputWithRemove/InputWithRemove';
import {Section} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/Section/Section';

export const HostContact = () => {
  const dispatch = useDispatch();
  const {phoneNumber: phone = init.phoneNumber} = useSelector(selectDetails);
  const [tempPhone, setTempPhone] = useState(phone);
  const [showPhone, setShowPhone] = useState(Boolean(phone));
  const [hasError, setHasError] = useState(false);

  const validatePhone = useCallback((phoneNumber: string) => {
    if (!phoneNumber) return true;
    const isValid = Boolean(parseUSPhoneNumber(phoneNumber).is_valid);
    setHasError(!isValid);
    return isValid;
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const updatePhone = useCallback(
    (phoneNumber: string) =>
      dispatch({
        type: UPDATE_EVENT_DETAILS,
        payload: {phoneNumber},
      }),
    []
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const removePhone = useCallback(() => {
    setTempPhone('');
    setHasError(false);
    updatePhone('');
    setShowPhone(false);
  }, []);

  const onChangeHandler: ChangeEventHandler<HTMLInputElement> = useCallback(({target: {value}}) => {
    setTempPhone(value);
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const onExitEditModeHandler = useCallback(() => {
    const prettyFormatPhoneNumber = parseUSPhoneNumber(tempPhone).formatted || tempPhone;
    setTempPhone(prettyFormatPhoneNumber);
    updatePhone(prettyFormatPhoneNumber);
  }, [tempPhone, parseUSPhoneNumber]);

  return (
    <>
      {showPhone && (
        <Section title="Contact Host">
          <InputWithRemove
            name="phone"
            dataQaId="event-phone"
            error={hasError ? 'Please enter a valid phone number' : false}
            maxLength={14}
            type="tel"
            value={tempPhone}
            onExitEditModeValidation={validatePhone}
            onExitEditMode={onExitEditModeHandler}
            onChange={onChangeHandler}
            placeholder="XXX-XXX-XXXX"
            onRemove={removePhone}
            fullWidth
          />
        </Section>
      )}

      {!showPhone && (
        <AddButtonWithTitle
          label="Host Phone Number"
          dataQaId="add-eventphonenum"
          onClick={() => {
            setShowPhone(!showPhone);
          }}
        />
      )}
    </>
  );
};
